// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__32H3R","overflowing":"ReadFullNote_overflowing__FIhj6"};